<div class="hw-box-content global-layout">
  <fn-tab [tabArray]="tabArray" [isVertical]="false" [dataTemplate]="tabDataTemplateRef" class="horizontalTab"></fn-tab>
  <ng-template #tabDataTemplateRef let-config>
    <div>
      <div class="login-data" [hidden]="config.templateId != 'data_1'">
        <div class="row">
          <div class="col-12">
            <ul class="list-inline">
              <li class="align-top width-210px">
                <fn-checkbox-filter class="checkbox-wrapper" [listItemArray]="schemaArray" [defaultDesc]="defaultDesc"
                  (cbSelectedItem)="selectSchema($event)" appendTo="body">
                </fn-checkbox-filter>
              </li>
              <li class="align-top width-210px">
                <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="dayArray"
                  [placeholder]="'Select Time Interval'" [(ngModel)]="selectedDay" appendTo="body"
                  [ngModelOptions]="{ standalone: true }">
                </fn-select>
              </li>
              <li class="align-top pt-7">
                <div class="form-check">
                  <label class="form-check-label" for="hostWise">Host Wise</label>
                </div>
              </li>
              <li class="align-top pt-7">
                <fn-switch [(ngModel)]="hostWise" [name]="'hostWise'"></fn-switch>
              </li>
              <li class="align-top pt">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'" (click)="getLoginData()">
                </fn-button>
              </li>
            </ul>
          </div>
          <div class="col-12">
            @if(!hasChartData){
            <fn-no-data-box [showImg]="true" [imgContainerheight]="'500'" [isVerticalImg]="false">
            </fn-no-data-box>
            }<div id="login_data" [hidden]="!hasChartData"></div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="off-clock" [hidden]="config.templateId != 'data_2'">
        <div class="row">
          <div class="col-12">
            <ul class="list-inline">
              <li class="align-top width-210px">
                <fn-checkbox-filter class="checkbox-wrapper" [listItemArray]="appArray" [defaultDesc]="defaultDesc"
                  appendTo="body" (cbSelectedItem)="selectApp($event)">
                </fn-checkbox-filter>
              </li>

              <li class="align-top width-210px">
                <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="minHourArray"
                  [placeholder]="'Select Time Interval'" [(ngModel)]="selectedClock" appendTo="body"
                  [ngModelOptions]="{ standalone: true }">
                </fn-select>
              </li>
              <li class="align-top pt-4">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                  (click)="getOffClock()"></fn-button>
              </li>

            </ul>
          </div>
          <div class="col-12">
            <div class="no_data_display" [hidden]="clockData.length > 0">
              No Data To Display
            </div>
            <div [hidden]="clockData.length === 0">
              <table class="table table-bordered clock-status-table m-0">
                <thead>
                  <tr class="bg-black">
                    <th colspan="5" class="text-center status-header">
                      <span class="font-22 white">
                        Clock Status Report for last {{minDayValue()}}
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center">Schema &nbsp;</th>
                    <th class="text-center">Total &nbsp;</th>
                    <th class="text-center">Online &nbsp;</th>
                    <th class="text-center">Offline &nbsp;</th>
                    <th class="text-center">Offline % &nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of clockData" [ngClass]="{'highlight-zero': item.perOffline >= 5}">
                    <td class="text-center">
                      <span [ngClass]="{'schema-highlight': isSchemaHighlighted(item.schemaID)}">
                        {{ item.schemaID }}</span>
                    </td>
                    <td>{{ item.totalCount }}</td>
                    <td>{{ item.onlineCount }}</td>
                    <td>{{ item.offlineCount }}</td>
                    <td>{{ item.perOffline }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-center">{{ totalRow.schemaID }}</td>
                    <td>{{ totalRow.totalCount }}</td>
                    <td>{{ totalRow.onlineCount }}</td>
                    <td>{{ totalRow.offlineCount }}</td>
                    <td>{{ totalRow.perOffline }} %</td>
                  </tr>
                </tfoot>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="offline-clock" [hidden]="config.templateId != 'data_4'">
        <div class="row">
          <div class="col-12">
            <ul class="list-inline">
              <li class="align-top width-210px">
                <fn-checkbox-filter class="checkbox-wrapper" [listItemArray]="appArray" [defaultDesc]="defaultDesc"
                  appendTo="body" (cbSelectedItem)="selectApp($event)">
                </fn-checkbox-filter>
              </li>
              @if(!chartView){
              <li class="align-top width-210px">
                <div class="col-12  mb-10">

                  <span class="description">
                    <fn-date-time-picker (callback)="changeEventDate($event)"></fn-date-time-picker>
                  </span>
                </div>
              </li>
              }
              @if(chartView){
              <li class="align-top width-210px">
                <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="hourDayArray"
                  [placeholder]="'Select Time Interval'" [(ngModel)]="selectedHour" appendTo="body"
                  [ngModelOptions]="{ standalone: true }">
                </fn-select>
              </li>
              }
              <li class="align-top pt-7">
                <div class="form-check">
                  <label class="form-check-label" for="chartView">Chart View</label>
                </div>
              </li>
              <li class="align-top pt-7">
                <fn-switch [(ngModel)]="chartView" [name]="'chartView'"></fn-switch>
              </li>
              <li class="align-top pt-4">
                <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                  (click)="getOfflineClock()"></fn-button>
              </li>
              @if(clockStatusData.length >0){
              <li class="align-top pt-4">
                <fn-button [type]="'success'" [btnClass]="'btn-sm btn-round'" [text]="'Download CSV'"
                  (click)="downloadCsv()"></fn-button>
              </li>
              }
            </ul>
          </div>
          <div class="col-12">
            <div class="no_data_display"
              [hidden]="(clockStatusData.length > 0 && !chartView) || (clockGraph.length > 0 && chartView)">
              No Data To Display
            </div>
            <div [hidden]="clockStatusData.length === 0 || chartView">
              <table class="table table-bordered clock-status-table m-0">
                <thead>
                  <tr class="bg-black">
                    <th colspan="5" class="text-center status-header">
                      <span class="font-22 white">
                        Clock Status At {{selectedDayMinValue}}
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <th class="text-center">Schema &nbsp;</th>
                    <th class="text-center">Total &nbsp;</th>
                    <th class="text-center">Online &nbsp;</th>
                    <th class="text-center">Offline &nbsp;</th>
                    <th class="text-center">Offline % &nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of clockStatusData" [ngClass]="{'highlight-zero': item.perOffline >= 5}">
                    <td class="text-center">
                      <span [ngClass]="{'schema-highlight': isSchemaHighlighted(item.schemaID)}">
                        {{ item.schemaID }}</span>
                    </td>
                    <td>{{ item.totalCount }}</td>
                    <td>{{ item.onlineCount }}</td>
                    <td>{{ item.offlineCount }}</td>
                    <td>{{ item.perOffline }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-center">{{ totalRow.schemaID }}</td>
                    <td>{{ totalRow.totalCount }}</td>
                    <td>{{ totalRow.onlineCount }}</td>
                    <td>{{ totalRow.offlineCount }}</td>
                    <td>{{ totalRow.perOffline }} %</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div id="offline_clock" [hidden]="!chartView || clockGraph.length === 0"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="hourly-graphs" [hidden]="config.templateId != 'data_3'">
      <div class="row">
        <div class="col-12">
          <ul class="list-inline">
            <li class="align-top width-210px">
              <fn-checkbox-filter class="checkbox-wrapper" [listItemArray]="schemaArray" [defaultDesc]="defaultDesc"
                appendTo="body" (cbSelectedItem)="selectSchema($event)">
              </fn-checkbox-filter>
            </li>
            <li class="align-top width-210px">
              <fn-select [labelKey]="'friendlyName'" [inputKey]="'name'" [optionList]="eventArray"
                [placeholder]="'Search EventId..'" [(ngModel)]="selectedEvent" appendTo="body"
                [ngModelOptions]="{ standalone: true }">
              </fn-select>
            </li>
            <li class="align-top width-210px">
              <div class="align-top width-210px">
                <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="dayArray"
                  [placeholder]="'Select Time Interval'" [(ngModel)]="selectedDay" appendTo="body"
                  [ngModelOptions]="{ standalone: true }">
                </fn-select>
              </div>
            </li>
            <li class="align-top pt">
              <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                (click)="getHourlyGraphs()"></fn-button>
            </li>
          </ul>
        </div>
        <div class="col-12">
          @if(isHourlyDataEmpty){
          <fn-no-data-box [showImg]="true" [imgContainerheight]="'500'" [isVerticalImg]="false">
          </fn-no-data-box>
          }<div id="hourly_graphs" [hidden]="isHourlyDataEmpty"></div>
        </div>
      </div>
    </div>

    <div class="daily-graphs" [hidden]="config.templateId != 'data_5'">
      <div class="row">
        <div class="col-12">
          <ul class="list-inline">
            <li class="align-top pt-7">
              <div class="form-check">
                <label class="form-check-label" for="customDate">Custom Date</label>
              </div>
            </li>
            <li class="align-top pt-7">
              <fn-switch [(ngModel)]="customDate" [name]="'customDate'"></fn-switch>
            </li>
            @if(customDate){
            <li class="align-top width-210px">
              <fn-date-range-picker [startDate]="dateRangeObject.startDate" [futureDateDisabled]="true"
                [maxDate]="maxDateRange" (dateCB)="changeDate($event)" [endDate]="dateRangeObject.endDate">
              </fn-date-range-picker>
            </li>
            }@if(!customDate){
            <li class="align-top width-210px">
              <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="dayRangeArray"
                [placeholder]="'selected Day'" appendTo="body" [(ngModel)]="selectedRange"
                [ngModelOptions]="{standalone: true}">
              </fn-select>
            </li>
            }
            <li class="align-top width-210px">
              <fn-select [labelKey]="'description'" [inputKey]="'id'" [optionList]="dailySchemaArray"
                [placeholder]="'Select Schema..'" [(ngModel)]="selectedDailySchema" appendTo="body"
                [ngModelOptions]="{ standalone: true }">
              </fn-select>
            </li>
            <li class="align-top width-210px">
              <fn-select [labelKey]="'friendlyName'" [inputKey]="'name'" [optionList]="eventArray"
                [placeholder]="'Search EventId..'" [(ngModel)]="selectedEvent" appendTo="body"
                [ngModelOptions]="{ standalone: true }">
              </fn-select>
            </li>
            <li class="align-top pt">
              <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                (click)="getDailyGraphs()"></fn-button>
            </li>
          </ul>
        </div>
        <div class="col-12">
          @if(!hasDailyData){
          <fn-no-data-box [showImg]="true" [imgContainerheight]="'500'" [isVerticalImg]="false">
          </fn-no-data-box>
          }<div id="daily_graphs" [hidden]="!hasDailyData"></div>
        </div>
      </div>
    </div>
    <div class="app-restart" [hidden]="config.templateId != 'data_6'">
      <div class="row">
        <div class="col-12">
          <ul class="list-inline">
            <li class="align-top width-210px">
              <fn-checkbox-filter class="checkbox-wrapper" [listItemArray]="appArray" [defaultDesc]="defaultDesc"
                appendTo="body" (cbSelectedItem)="selectApp($event)">
              </fn-checkbox-filter>
            </li>
            <li class="align-top width-210px">
              <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="hourDayArray"
                [placeholder]="'Select Time Interval'" [(ngModel)]="selectedHour" appendTo="body"
                [ngModelOptions]="{ standalone: true }">
              </fn-select>
            </li>
            <li class="align-top pt-7">
              <div class="form-check">
                <label class="form-check-label" for="hostwise">Hostwise</label>
              </div>
            </li>
            <li class="align-top pt-7">
              <fn-switch [(ngModel)]="hostwise" [name]="'hostwise'" (ngModelChange)="onHostwiseToggle()"></fn-switch>
            </li>

            <li class="align-top pt-7">
              <div class="form-check">
                <label class="form-check-label" for="chartView">Chart View</label>
              </div>
            </li>
            <li class="align-top pt-7">
              <fn-switch [(ngModel)]="chartView" [name]="'chartView'" (ngModelChange)="onChartViewTogle()"></fn-switch>
            </li>
            <li class="align-top pt-4">
              <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                (click)="getAppRestart()"></fn-button>
            </li>
            @if(appRestartData.length >0){
            <li class="align-top pt-4">
              <fn-button [type]="'success'" [btnClass]="'btn-sm btn-round'" [text]="'Download CSV'"
                (click)="downloadCsv()"></fn-button>
            </li>
            }
          </ul>
        </div>
        <div class="col-12">
          <div class="no_data_display" [hidden]="appRestartData.length > 0">
            No Data To Display
          </div>
          <div [hidden]="appRestartData.length === 0 || chartView || hostwise">
            <table class="table table-bordered clock-status-table m-0">
              <thead>
                <tr class="bg-black">
                  <th colspan="5" class="text-center status-header">
                    <span class="font-22 white">
                      App Log Status Report for last {{hourDayValue()}}
                    </span>
                  </th>
                </tr>
                <tr>
                  <th class="text-center">Schema &nbsp;</th>
                  <th class="text-center">Count &nbsp;</th>
                  <th class="text-center">Average Time Taken(Sec) &nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of appRestartData">
                  <td class="text-center">
                    <span>
                      {{ item.schemaID }}</span>
                  </td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.average }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="text-center">{{ totalAppRow.schemaID }}</td>
                  <td>{{ totalAppRow.count }}</td>
                  <td>{{ totalAppRow.average }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div [hidden]="appRestartHost.length === 0 || chartView || !hostwise">
            <table class="table table-bordered clock-status-table m-0">
              <thead>
                <tr class="bg-black">
                  <th colspan="5" class="text-center status-header">
                    <span class="font-22 white">
                      App Log Status Report for last {{hourDayValue()}}
                    </span>
                  </th>
                </tr>
                <tr>
                  <th class="text-center">Host Name &nbsp;</th>
                  <th class="text-center">Count &nbsp;</th>
                  <th class="text-center">Average Time Taken(Sec) &nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of appRestartHost">
                  <td class="text-center">
                    <span>
                      {{ item.hostName }}</span>
                  </td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.avg }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="text-center">{{ totalHostRow.hostName }}</td>
                  <td>{{ totalHostRow.count }}</td>
                  <td>{{ totalHostRow.avg }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div id="app_restart" [hidden]="appRestartData.length === 0 || !chartView"></div>
          <!-- Modal for chartData bar click -->
          <div class="modal" [ngClass]="{'show': showModal}" [ngStyle]="{'display': showModal ? 'block' : 'none'}">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Host Counts (Chart Data)</h5>
                  <button type="button" class="close" (click)="closeModal('chartData')">&times;</button>
                </div>
                <div class="modal-body">
                  <div id="modal-chart"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modals for schema-wise timeWise graphs -->
          <div *ngFor="let sg of schemaGraphData" class="modal" [ngClass]="{'show': showSchemaModal[sg.schema]}"
            [ngStyle]="{'display': showSchemaModal[sg.schema] ? 'block' : 'none'}">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Host Counts (Schema: {{ sg.schema }})</h5>
                  <button type="button" class="close" (click)="closeModal(sg.schema)">&times;</button>
                </div>
                <div class="modal-body">
                  <div [id]="'modal-chart-' + sg.schema"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="site-clock" [hidden]="config.templateId != 'data_7'">
      <div class="row">
        <div class="col-12">
          <ul class="list-inline">
            <li class="align-top width-210px">
              <fn-checkbox-filter class="checkbox-wrapper" [listItemArray]="appArray" [defaultDesc]="defaultDesc"
                appendTo="body" (cbSelectedItem)="selectApp($event)">
              </fn-checkbox-filter>
            </li>
            @if(!siteChartView){
            <li class="align-top width-210px">
              <div class="col-12  mb-10">

                <span class="description">
                  <fn-date-time-picker (callback)="changeEventDate($event)"></fn-date-time-picker>
                </span>
              </div>
            </li>
            }
            @if(siteChartView){
            <li class="align-top width-210px">
              <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="hourDayArray"
                [placeholder]="'Select Time Interval'" [(ngModel)]="selectedHour" appendTo="body"
                [ngModelOptions]="{ standalone: true }">
              </fn-select>
            </li>
            }
            <li class="align-top pt-7">
              <div class="form-check">
                <label class="form-check-label" for="siteChartView">Chart View</label>
              </div>
            </li>
            <li class="align-top pt-7">
              <fn-switch [(ngModel)]="siteChartView" [name]="'siteChartView'"></fn-switch>
            </li>
            <li class="align-top pt-4">
              <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                (click)="getSiteClock()"></fn-button>
            </li>

          </ul>
        </div>
      </div>
      <div class="col-12">
        <div class="no_data_display"
          [hidden]="(siteClockData.length > 0 && !siteChartView) || (siteGraph.length > 0 && siteChartView)">
          No Data To Display
        </div>
        <div [hidden]="siteClockData.length === 0 || siteChartView">
          <table class="table table-bordered clock-status-table m-0">
            <thead>
              <tr class="bg-black">
                <th colspan="5" class="text-center status-header">
                  <span class="font-22 white">
                    Site Clock Offline At {{selectedDayMinValue}}
                  </span>
                </th>
              </tr>
              <tr>
                <th class="text-center">Schema &nbsp;</th>
                <th class="text-center">No. Of Store &nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of siteClockData">
                <td class="text-center">
                  <span [ngClass]="{'schema-highlight': isClockHighlighted(item.schemaID)}">
                    {{ item.schemaID }}
                  </span>
                </td>
                <td>{{ item.count }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="text-center">{{ totalSiteRow.schemaID }}</td>
                <td>{{ totalSiteRow.count }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div id="site_clock" [hidden]="!siteChartView || siteGraph.length === 0"></div>
      </div>
    </div>

    <div class="context-event" [hidden]="config.templateId != 'data_9'">
      <div class="row">
        <div class="col-12">
          <ul class="list-inline">
            <li class="align-top width-210px">
              <fn-checkbox-filter class="checkbox-wrapper" [listItemArray]="schemaArray" [defaultDesc]="defaultDesc"
                appendTo="body" (cbSelectedItem)="selectSchema($event)">
              </fn-checkbox-filter>
            </li>
            <li class="align-top width-210px">
              <div class="align-top width-210px">
                <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="dayArray"
                  [placeholder]="'Select Time Interval'" [(ngModel)]="selectedDay" appendTo="body"
                  [ngModelOptions]="{ standalone: true }">
                </fn-select>
              </div>
            </li>
            <li class="align-top width-210px">
              <fn-select [labelKey]="'friendlyName'" [inputKey]="'name'" [optionList]="hostEventArray"
                [placeholder]="'Search EventId..'" [(ngModel)]="selectedHostEvent" appendTo="body"
                [ngModelOptions]="{ standalone: true }">
              </fn-select>
            </li>
            <li class="align-top pt">
              <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                (click)="getContextEvent()"></fn-button>
            </li>
          </ul>
        </div>
        <div class="col-12">
          @if(!hasHostData){
          <fn-no-data-box [showImg]="true" [imgContainerheight]="'500'" [isVerticalImg]="false">
          </fn-no-data-box>
          }<div id="context_event" [hidden]="!hasHostData"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<style>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .modal.show .modal-dialog {
    transform: translate(0, 50%);
  }

  .modal-dialog {
    max-width: 600px;
    margin: 1.75rem auto;
  }

  .modal-content {
    background-color: #fff;
    border-radius: 0.3rem;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
  }

  .modal-title {
    margin: 0;
  }

  .close {
    font-size: 1.5rem;
    line-height: 1;
    background: none;
    border: none;
    cursor: pointer;
  }

  .modal-body {
    padding: 1rem;
  }

  #modal-chart,
  [id^="modal-chart-"] {
    width: 100%;
    height: 300px;
  }
</style>